import Portfolio from "../../../commonComponents/portfolio";

const PortfolioBoxSliderContainer = () => {
  return <Portfolio type="box_slider" gridSize={3} carShow={9} />;
};

export default PortfolioBoxSliderContainer;
